
/**
 * Below are the colors that are used in the app. The colors are defined in the light and dark mode.
 * There are many other ways to style your app. For example, [Nativewind](https://www.nativewind.dev/), [Tamagui](https://tamagui.dev/), [unistyles](https://reactnativeunistyles.vercel.app), etc.
 */

const tintColorLight = '#151515';
const tintColorDark = '#F9F8F3';

export const Colors = {
  light: {
    text: '#151515',
    background: '#F9F8F3',
    tint: tintColorLight,
    icon: '#A19F97',
    tabIconDefault: '#A19F97',
    tabIconSelected: tintColorLight,
    
    // Semantic colors
    primary: '#151515',
    secondary: '#C0D1DB',
    success: '#10B981',
    error: '#EF4444',
    warning: '#DE5609',
    
    // Surface colors
    surface: '#FFFFFF',
    surfaceSecondary: '#F9F8F3',
    
    // Text colors
    textPrimary: '#151515',
    textSecondary: '#757C85',
    textInverse: '#FFFFFF',
    
    // Border colors
    border: '#C0D1DB',
    borderLight: '#E7EAED',
    borderDisabled: '#DAD8CF',
    // Existing sponsorship/gender option-card palette, shared by new steps.
    onboardingSelection: {
      border: '#F0EEE4',
      selectedBorder: '#004165',
      selectedSurface: '#E6EBF0',
      radioBorder: '#7E7D75',
      accent: '#015480',
    },
    
    // Neutral colors
    neutral100: '#F9F8F3',
    neutral200: '#E7EAED',
    neutral300: '#DAD8CF',
    neutral400: '#A19F97',
    neutral500: '#757C85',
    neutral900: '#151515',
  },
  dark: {
    text: '#F9F8F3',
    background: '#151515',
    tint: tintColorDark,
    icon: '#A19F97',
    tabIconDefault: '#A19F97',
    tabIconSelected: tintColorDark,
    
    // Semantic colors (adjusted for dark mode)
    primary: '#F9F8F3',
    secondary: '#5A7A8A',
    success: '#34D399',
    error: '#F87171',
    warning: '#F59E0B',
    
    // Surface colors
    surface: '#1F2937',
    surfaceSecondary: '#111827',
    
    // Text colors
    textPrimary: '#F9F8F3',
    textSecondary: '#9CA3AF',
    textInverse: '#151515',
    
    // Border colors
    border: '#374151',
    borderLight: '#4B5563',
    borderDisabled: '#6B7280',
    
    // Neutral colors (inverted for dark mode)
    neutral100: '#1F2937',
    neutral200: '#374151',
    neutral300: '#4B5563',
    neutral400: '#6B7280',
    neutral500: '#9CA3AF',
    neutral900: '#F9F8F3',
  },
};
